<template>
  <header class="menu-mobile-header d-flex justify-content-between align-items-center px-3 py-2">
    <router-link
      :to="isLogged ? '/my-account/dashboard' : '/'"
      class="logo"
      aria-label="Página inicial ou Dashboard"
    >
      <AppLogo :height="36" />
    </router-link>

    <div class="header-actions">
      <div v-if="isLogged" class="mobile-profile" ref="profileMenuRef">
        <button
          type="button"
          class="mobile-profile__avatar"
          aria-label="Abrir menu do perfil"
          @click.stop="toggleProfileDropdown"
        >
          <img v-if="userAvatarURL" :src="userAvatarURL" :alt="userInitial" class="mobile-profile__avatar-img" referrerpolicy="no-referrer" />
          <template v-else>{{ userInitial }}</template>
        </button>

        <div v-if="showProfileDropdown" class="mobile-profile__dropdown">
          <button type="button" class="mobile-profile__item" @click="goToProfileFromHeader">Editar Perfil</button>
          <button type="button" class="mobile-profile__item" @click="goToPixFromHeader">Dados Bancarios</button>
          <button type="button" class="mobile-profile__item" @click="openChangePasswordFromHeader">Alterar Senha</button>
          <button type="button" class="mobile-profile__item mobile-profile__item--danger" @click="openLogoutConfirmation">Sair</button>
        </div>
      </div>

      <button class="menu-button" @click="toggleMenu" :aria-expanded="showMenu ? 'true' : 'false'" aria-controls="mobile-menu-fullscreen-id" aria-label="Alternar menu de navegação">
        <div class="hamburger-icon" :class="{ 'open': showMenu }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
    </div>
  </header>

  <transition name="fade">
    <div v-if="showMenu" id="mobile-menu-fullscreen-id" class="mobile-menu-fullscreen position-fixed top-0 start-0 w-100 h-100 bg-white d-flex flex-column justify-content-center align-items-center p-4">
      <button class="close-btn position-absolute top-0 end-0 m-4" @click="toggleMenu" aria-label="Fechar menu">
        ✕
      </button>

      <div v-if="!isLogged" class="mobile-menu-guest-logo">
        <router-link to="/" @click="toggleMenu" aria-label="Ir para início">
          <AppLogo :height="42" />
        </router-link>
      </div>

      <div class="menu-content text-center">
        <div class="menu-top-links">
          <div v-if="['event', 'checkout', 'cart', 'payment-success'].includes(page)">
              <router-link class="mobile-menu-link" :to="`/event/${eventId}`" @click="toggleMenu">Lista de Presentes</router-link>
              <a class="mobile-menu-link" v-if="page !== 'cart' && page !== 'payment-success'" href="#" @click.prevent="handleGoToCart">Ir para o carrinho</a>
          </div>
          <div v-else-if="isLogged">
              <div class="account-dropdown">
                  <span class="account-section-label">Minha Conta</span>
                  <ul class="dropdown-menu-list">
                  <li><router-link class="mobile-menu-link" to="/my-account/dashboard" @click="toggleMenu">Início</router-link></li>
                  <li><router-link class="mobile-menu-link" to="/my-account/events" @click="toggleMenu">Meus Eventos</router-link></li>
                  <li><router-link class="mobile-menu-link" to="/finance" @click="toggleMenu">Minhas Finanças</router-link></li>                      
                  <li v-if="auth.isAdmin"><router-link class="mobile-menu-link" to="/admin/withdrawals" @click="toggleMenu">Extrato de Saques</router-link></li>

                  <li v-if="auth.isAdmin"><router-link class="mobile-menu-link" to="/admin/finance" @click="toggleMenu">Dashboard Financeiro</router-link></li>
                    <li v-if="auth.isAdmin"><router-link class="mobile-menu-link" to="/admin/event-payouts" @click="toggleMenu">Eventos e Repasses</router-link></li>
                  <li v-if="auth.isAdmin"><router-link class="mobile-menu-link" to="/admin/legal" @click="toggleMenu">Documentos Legais</router-link></li>
                  </ul>
              </div>
          </div>
          <div v-else>
              <router-link class="mobile-menu-link" to="/" @click="toggleMenu">Início</router-link>
              <router-link class="mobile-menu-link" to="/how-it-works" @click="toggleMenu">Como Funciona</router-link>
              <router-link class="mobile-menu-link" to="/login" @click="toggleMenu">Entrar</router-link>
              <router-link class="mobile-menu-link" to="/register" @click="toggleMenu">Cadastrar</router-link>
              <router-link to="/my-account/add" @click="toggleMenu" class="mobile-cta-link">
                Criar minha lista
              </router-link>
          </div>
        </div>

        <div class="menu-separator my-4">
            <div class="separator-line"></div>
        </div>

        <div class="menu-base-links">
          <a v-if="isEventMode" class="icon-cart" href="#" @click.prevent="handleGoToCart" aria-label="Ir para o carrinho">
            Carrinho <i class="fas fa-shopping-cart"></i>
          </a>

          <div v-if="!isLogged" class="extra-links mt-4">
            <router-link to="/termos-de-uso" @click="toggleMenu">Termos de Uso</router-link>
            <router-link to="/politica-de-privacidade" @click="toggleMenu">Política de Privacidade</router-link>
            <router-link to="/termos-de-saque" @click="toggleMenu">Regras de Saque</router-link>
            <router-link to="/contact" @click="toggleMenu">Contato</router-link>
          </div>

          <div v-if="!isLogged" class="social-icons mt-4">
           <a href="https://www.facebook.com/quemimoapp" 
            aria-label="Acessar nossa página no Facebook"
            target="_blank" rel="noopener noreferrer">
              <i class="fa-brands fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/quemimoapp" 
            aria-label="Acessar nosso perfil no Instagram"
            target="_blank" rel="noopener noreferrer">
              <i class="fa-brands fa-instagram"></i>
          </a>
          <a href="https://www.threads.net/@quemimoapp" 
            aria-label="Acessar nosso perfil no Threads"
            target="_blank" rel="noopener noreferrer" class="social-icon-svg">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M141.537 88.988a66.667 66.667 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.396-35.12 18.036l13.779 9.452c5.73-8.695 14.724-10.548 21.348-10.548h.23c8.248.054 14.474 2.452 18.515 7.129 2.932 3.405 4.893 8.111 5.864 14.05-7.314-1.243-15.224-1.626-23.68-1.14-23.82 1.371-39.134 15.264-38.105 34.568.522 9.792 5.4 18.216 13.735 23.719 7.047 4.652 16.124 6.927 25.557 6.412 12.458-.683 22.231-5.436 29.05-14.127 5.177-6.6 8.452-15.153 9.898-25.93 5.937 3.583 10.337 8.298 12.767 13.966 4.132 9.635 4.373 25.468-8.546 38.376-11.319 11.308-24.925 16.2-45.488 16.351-22.809-.169-40.06-7.484-51.275-21.742C35.236 139.966 29.808 120.682 29.605 96c.203-24.682 5.63-43.966 16.133-57.317C56.954 24.425 74.204 17.11 97.013 16.94c22.975.17 40.526 7.52 52.171 21.847 5.71 7.026 10.015 15.86 12.853 26.162l16.147-4.308c-3.44-12.68-8.853-23.606-16.219-32.668C147.036 9.607 125.202.195 97.07 0h-.113C68.882.195 47.292 9.643 32.788 28.08 19.882 44.485 13.224 67.315 13.001 96v.027c.223 28.682 6.88 51.512 19.787 67.916 14.504 18.438 36.094 27.886 64.174 28.08h.113c24.999-.169 42.557-6.727 57.03-21.19 18.963-18.945 18.392-42.692 12.142-57.27-4.484-10.454-13.033-18.945-24.71-24.575Zm-43.096 40.52c-10.426.576-21.263-4.095-21.82-14.079-.427-8.013 5.701-16.936 24.084-18.008 2.105-.122 4.17-.179 6.197-.179 6.303 0 12.196.609 17.587 1.774-2.003 24.993-15.51 29.888-26.048 30.492Z"/></svg>
          </a>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <ChangePasswordModal
    :visible="showChangePasswordModal"
    @close="showChangePasswordModal = false"
  />

  <BottomModal
    :visible="showLogoutConfirmation"
    @close="showLogoutConfirmation = false"
    :fullHeight="false"
  >
    <template #default>
      <div class="confirmation-content p-3 text-center">
        <h5 class="mb-3 text-primary-emphasis">Confirmar Saída?</h5>
        <p class="text-muted mb-4">
          Ao sair, você será desconectado(a). Na sua próxima visita, será necessário informar sua senha para acessar sua conta novamente.
        </p>
        <div class="d-flex justify-content-center gap-3 mt-4">
          <button class="btn btn-sm btn-outline-secondary" @click="showLogoutConfirmation = false">
            <i class="fa-solid fa-chevron-down me-2"></i>
          </button>
          <button class="btn btn-sm btn-color-site" @click="confirmLogout">
            <span v-if="isLoggingOut" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isLoggingOut ? 'Saindo...' : 'Confirmar Saída' }}
          </button>
        </div>
      </div>
    </template>
  </BottomModal>

  <BottomModal
    :visible="showEmptyCartModal"
    @close="showEmptyCartModal = false"
    :fullHeight="false"
  >
    <template #default>
      <div class="confirmation-content p-3 text-center">
        <div class="mb-3" style="font-size: 2.5rem; color: var(--event-primary, #e91e8c);">
          <i class="fas fa-basket-shopping"></i>
        </div>
        <h5 class="mb-2">Carrinho vazio</h5>
        <p class="text-muted mb-4">
          Você ainda não selecionou nenhum presente. Escolha os itens que deseja presentear na lista de presentes.
        </p>
        <div class="d-flex justify-content-center gap-3">
          <button class="btn btn-sm btn-outline-secondary" @click="showEmptyCartModal = false">
            <i class="fa-solid fa-chevron-down me-2"></i>Fechar
          </button>
          <router-link :to="`/event/${eventId}`" class="btn btn-sm btn-color-site" @click="showEmptyCartModal = false">
            <i class="fas fa-gift me-2"></i>Ver presentes
          </router-link>
        </div>
      </div>
    </template>
  </BottomModal>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAlertStore } from '@/stores/alertStore';
import { useAuthStore } from '@/stores/authStore';
import { useEventStore } from '@/stores/eventStore';
import { useCartStore } from '@/stores/cartStore';
import ChangePasswordModal from '@/components/ChangePasswordModal.vue';
import BottomModal from '@/components/BottomModal.vue';
import AppLogo from '@/components/AppLogo.vue';

const showMenu = ref(false);
const showProfileDropdown = ref(false);
const showChangePasswordModal = ref(false);
const showLogoutConfirmation = ref(false);
const showEmptyCartModal = ref(false);
const isLoggingOut = ref(false);
const profileMenuRef = ref(null);
const router = useRouter();

function toggleMenu() {
  showMenu.value = !showMenu.value;
  showProfileDropdown.value = false;
  if (showMenu.value) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

const auth = useAuthStore();
const eventStore = useEventStore();
const cart = useCartStore();
const route = useRoute();
const alert = useAlertStore();

function handleGoToCart() {
  const items = cart.getEvent(eventId.value)?.items || [];
  if (items.length === 0) {
    showMenu.value = false;
    document.body.style.overflow = '';
    showEmptyCartModal.value = true;
  } else {
    toggleMenu();
    router.push(`/checkout/${eventId.value}`);
  }
}

const isLogged = computed(() => auth.isAuthenticated);
const isEventMode = computed(() => eventStore.isEventMode);
const eventId = computed(() => {
  const path = route.path;
  const id = route.params.id;

  if (path.startsWith('/event/') || path.startsWith('/cart/') || path.startsWith('/checkout/') || path.startsWith('/payment-success/')) {
    return id;
  }
  return null;
});

const page = computed(() => {
  const path = route.path;
  if (path.startsWith('/event/')) return 'event';
  if (path.startsWith('/cart/')) return 'cart';
  if (path.startsWith('/checkout/')) return 'checkout';
  if (path.startsWith('/my-account')) return 'account';
  if (path.startsWith('/payment-success')) return 'payment-success';
  return 'default';
});

const userDisplayName = computed(() => auth.user?.name || 'Usuário');
const userAvatarURL = computed(() => auth.user?.avatar_url || '');
const userInitial = computed(() => {
  const normalized = userDisplayName.value.trim();
  return (normalized.charAt(0) || 'U').toUpperCase();
});

function toggleProfileDropdown() {
  showProfileDropdown.value = !showProfileDropdown.value;
  showMenu.value = false;
  document.body.style.overflow = '';
}

function goToProfileFromHeader() {
  showProfileDropdown.value = false;
  router.push('/my-account/profile');
}

function goToPixFromHeader() {
  showProfileDropdown.value = false;
  router.push('/my-account/bank');
}

function openChangePasswordFromHeader() {
  showProfileDropdown.value = false;
  showChangePasswordModal.value = true;
}

function openLogoutConfirmation() {
  showProfileDropdown.value = false;
  showLogoutConfirmation.value = true;
}

function confirmLogout() {
  if (isLoggingOut.value) return;
  isLoggingOut.value = true;

  showProfileDropdown.value = false;
  alert.loading(true);
  auth.logout();
  router.push('/login');
  alert.close();
  showLogoutConfirmation.value = false;
  showMenu.value = false;
  document.body.style.overflow = '';
  isLoggingOut.value = false;
}

function handleOutsideClick(event) {
  if (!profileMenuRef.value) return;
  if (!profileMenuRef.value.contains(event.target)) {
    showProfileDropdown.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleOutsideClick);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleOutsideClick);
  document.body.style.overflow = '';
});
</script>

<style scoped>
/* Variáveis CSS para Cores (Recomendado para consistência com o desktop) */
:root {
  --primary-color: var(--event-primary, #f78da7); /* Rosa principal */
  --secondary-color: #32355d; /* Azul escuro principal */
  --text-muted-color: #8f9093; /* Cinza para texto secundário */
  --border-line-color: #ececec; /* Cor da linha separadora */
}

.menu-mobile-header {
  width: -webkit-fill-available;
  height: 60px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  z-index: 1030;
  /* REMOVIDO: position: relative; (O pai no App.vue já é fixed-top) */
  /* ADICIONADO: padding-top para compensar a safe-area-inset-top */
  padding-top: env(safe-area-inset-top, 0px); /* CRÍTICO: Adiciona padding para a área segura do iOS */
}

.logo img {
  max-height: 32px;
}

/* ---------------------------------------------------- */
/* ESTILOS DO BOTÃO DE SANDUÍCHE E HAMBURGER-ICON       */
/* ---------------------------------------------------- */
.menu-button {
  background: none;
  border: none;
  padding: 10px; /* Aumenta a área de toque do botão */
  cursor: pointer;
  z-index: 1061; /* Para garantir que esteja acima do menu aberto */
  display: flex; /* Para centralizar o ícone dentro do botão */
  align-items: center;
  justify-content: center;
  position: relative; /* Pode manter se precisar de posicionamento interno, mas não afeta o menu */
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-profile {
  position: relative;
}

.mobile-profile__avatar {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: var(--event-primary, #ff50a3);
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0;
}

.mobile-profile__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.mobile-profile__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 170px;
  background: #fff;
  border: 1px solid #f1e9f2;
  border-radius: 10px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);
  padding: 6px;
  z-index: 1070;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mobile-profile__item {
  border: none;
  background: transparent;
  text-align: left;
  width: 100%;
  border-radius: 8px;
  padding: 8px 10px;
  color: #32355d;
  font-size: 0.82rem;
  font-weight: 600;
}

.mobile-profile__item:hover {
  background: #fff0f7;
  color: var(--event-primary, #ff50a3);
}

.mobile-profile__item--danger:hover {
  background: #fff1f1;
  color: #d14343;
}

.hamburger-icon {
  width: 28px; /* Largura do ícone */
  height: 20px; /* Altura total do ícone (espaço das 3 linhas) */
  position: relative;
  transform: rotate(0deg);
  transition: .3s ease-in-out;
  cursor: pointer;
}

.hamburger-icon span {
  display: block;
  position: absolute;
  height: 3px; /* Espessura das linhas */
  width: 100%;
  background: var(--secondary-color); /* Cor das linhas */
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: .25s ease-in-out;
}

/* Posição inicial das 3 linhas */
.hamburger-icon span:nth-child(1) {
  top: 0px;
}

.hamburger-icon span:nth-child(2) {
  top: 8.5px; /* Posição da linha do meio */
}

.hamburger-icon span:nth-child(3) {
  top: 17px; /* Posição da linha de baixo */
}

/* Estado "open" (menu aberto) - Transformação em "X" */
.hamburger-icon.open span:nth-child(1) {
  top: 8.5px; /* Move para o centro */
  transform: rotate(135deg); /* Gira para formar o "X" */
}

.hamburger-icon.open span:nth-child(2) {
  opacity: 0; /* Faz a linha do meio desaparecer */
  left: -28px; /* Move para fora da vista para uma transição mais suave */
}

.hamburger-icon.open span:nth-child(3) {
  top: 8.5px; /* Move para o centro */
  transform: rotate(-135deg); /* Gira na direção oposta para formar o "X" */
}

/* ---------------------------------------------------- */
/* MENU FULLSCREEN (o que aparece quando clicado)       */
/* ---------------------------------------------------- */
.mobile-menu-fullscreen {
  z-index: 1050; /* Acima do header, mas abaixo do botão fechar */
  /* Propriedades de flexbox para centralizar conteúdo */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Centraliza verticalmente */
  align-items: center; /* Centraliza horizontalmente */
  text-align: center; /* Para o texto dentro dos links */
  background-color: white; /* Garante que o fundo é branco */
  overflow-y: auto; /* Para permitir scroll se o conteúdo for muito grande */
  -webkit-overflow-scrolling: touch; /* Melhor scroll em iOS */
  /* Altura da viewport para cobrir toda a tela, considerando barras de endereços */
  height: 100dvh;
  height: 100vh; /* Fallback para navegadores mais antigos */
  /* Certifica-se que ocupa toda a tela */
  top: 0;
  left: 0;
  width: 100%;
  position: fixed; /* Essencial para ser fullscreen */
  /* ADICIONADO: padding-top para o menu fullscreen também, para que o botão de fechar não fique escondido */
  padding-top: env(safe-area-inset-top, 0px);
}

.close-btn {
  background: none;
  border: none;
  font-size: 2rem; /* Tamanho maior para fácil clique */
  color: var(--secondary-color);
  cursor: pointer;
  padding: 1rem;
  z-index: 1060; /* Acima do conteúdo do menu */
}

.mobile-menu-guest-logo {
  margin-bottom: 1.1rem;
}

.mobile-menu-guest-logo img {
  display: block;
  opacity: 0.92;
}

.menu-content {
  width: 100%;
  max-width: 300px; /* Limita a largura do conteúdo para não ficar muito esticado */
  padding: 1rem;
}

/* Estilos dos links principais - unificados (logado/deslogado) */
.mobile-menu-link {
  display: block;
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--text-muted-color);
  text-decoration: none;
  margin: 0.4rem 0;
  transition: color 0.2s;
}

.mobile-menu-link:hover,
.mobile-menu-link.router-link-exact-active {
  color: var(--primary-color);
}

/* Separador */
.menu-separator {
  padding: 1.5rem 0;
}

.separator-line {
  width: 80%; /* Linha mais curta para centralizar */
  margin: 0 auto; /* Centraliza a linha */
  border-bottom: 1px solid var(--border-line-color);
}

/* Links da base (extra-links, social-icons) */
.menu-base-links .icon-cart {
  font-size: 1.5rem;
  color: var(--secondary-color);
  text-decoration: none;
  display: block;
  margin-bottom: 1rem;
}

.menu-base-links .extra-links a {
  display: block;
  color: var(--text-muted-color);
  text-decoration: none;
  margin: 0.5rem 0;
  font-size: 1.2rem;
  transition: color 0.3s;
}

.menu-base-links .extra-links a:hover {
  color: var(--primary-color);
}

/* CTA "Criar minha lista" no menu guest */
.mobile-cta-link {
  display: inline-block;
  color: var(--event-primary, #ff50a3) !important;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.05rem;
  border-bottom: 1px solid var(--event-primary-shadow, rgba(255, 80, 163, 0.35));
  padding-bottom: 1px;
  margin-top: 0.35rem;
  transition: color 0.18s ease, border-color 0.18s ease;
}

.mobile-cta-link:hover {
  color: #e64593 !important;
  border-color: rgba(230, 69, 147, 0.55);
}

.menu-base-links .social-icons {
  margin-top: 2rem;
  display: flex;
  justify-content: center; /* Centraliza os ícones sociais */
  gap: 1rem;
}

.menu-base-links .social-icons a {
  color: var(--secondary-color);
  font-size: 1.8rem;
  transition: color 0.3s;
  text-decoration: none;
}

.menu-base-links .social-icons a:hover {
  color: var(--primary-color);
}

.menu-base-links .social-icons .social-icon-svg svg {
  display: block;
}

/* Estilos do Dropdown (list) para o menu mobile fullscreen */
.account-section-label {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #32355d;
  margin-bottom: 0.65rem;
  cursor: default;
  user-select: none;
}

.dropdown-menu-list {
  margin-top: 0;
  padding: 0;
  list-style: none;
}

.dropdown-menu-list li {
  margin-bottom: 0.5rem;
}

.dropdown-menu-list a,
.logout {
  cursor: pointer;
}

/* Transição de fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ── Card guest comprador (mobile) ── */
.guest-card-mobile {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #fff0f7;
  border: 1.5px solid #ffd6eb;
  border-radius: 0.875rem;
  padding: 0.7rem 0.875rem;
  text-decoration: none;
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  transition: background 0.2s, border-color 0.2s;
}
.guest-card-mobile:hover {
  background: #ffe0f0;
  border-color: var(--event-primary, #ff50a3);
}
.guest-card-mobile-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--event-primary, #ff50a3);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.guest-card-mobile-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  text-align: left;
}
.guest-card-mobile-name {
  font-size: 0.875rem;
  font-weight: 700;
  color: #32355d;
  line-height: 1.2;
}
.guest-card-mobile-label {
  font-size: 0.75rem;
  color: var(--event-primary, #ff50a3);
  font-weight: 600;
}

.confirmation-content h5 { font-size: 1.25rem; font-weight: 600; }
.confirmation-content p  { font-size: 0.95rem; }

.btn-color-site {
  background-color: var(--event-primary, #ff50a3);
  color: #fff;
  border: 1px solid var(--event-primary, #ff50a3);
  padding: 0.85rem 1.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 0.5rem;
  transition: all 0.2s ease-in-out;
}

.btn-color-site:hover:not(:disabled) {
  background-color: #e64593;
  border-color: #e64593;
  color: #fff;
}

.btn-color-site:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-outline-secondary {
  background-color: transparent;
  color: #6c757d;
  border: 1px solid #ced4da;
  padding: 0.85rem 1.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 0.5rem;
  transition: all 0.2s ease-in-out;
}

.btn-outline-secondary:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
  color: #495057;
}

.spinner-border {
  vertical-align: -0.125em;
}
</style>